import { UseMutationResult, useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ErrorResponse } from '@src/interface/api/response.interface'
import {
	UpdateVendorProfilePayload,
	UpdateVendorProfileResponse,
	updateVendorProfile,
} from '@src/lib/api/vendors/updateVendorProfile'

const useUpdateVendorProfileMutate = (
	vendorNo: string,
): UseMutationResult<
	UpdateVendorProfileResponse,
	AxiosError<ErrorResponse>,
	UpdateVendorProfilePayload
> => {
	const queryClient = useQueryClient()
	return useMutation((payload) => updateVendorProfile(vendorNo, payload), {
		async onSuccess() {
			await queryClient.invalidateQueries([
				{ queryKey: ['vendor-profile', vendorNo] },
				{ queryKey: ['vendor-info', vendorNo] },
			])
		},
	})
}

export default useUpdateVendorProfileMutate
